import { Card, Stack, Alert } from '@mui/material'
import FloodSummary from './flood/FloodSummary'
import FloodDepth from './flood/FloodDepth'
import FloodDamageLoss from './flood/FloodDamageLoss'

const PropertyFlood: React.FC<any> = ({ propertyId, emissionTier }) => {
  if (!propertyId) return <Alert severity="info">Select a property to view flood metrics.</Alert>

  return (
    <Stack spacing={4}>
      <Card sx={{ p: 3 }}>
        <FloodSummary propertyId={propertyId} emissionTier={emissionTier} />
      </Card>
      <Card sx={{ p: 3 }}>
        <FloodDamageLoss propertyId={propertyId} emissionTier={emissionTier} />
      </Card>
      <Card sx={{ p: 3 }}>
        <FloodDepth propertyId={propertyId} emissionTier={emissionTier} />
      </Card>
    </Stack>
  )
}

export default PropertyFlood
